import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=a634dfb8&scoped=true"
import script from "./userinfo.vue?vue&type=script&lang=js"
export * from "./userinfo.vue?vue&type=script&lang=js"
import style0 from "./userinfo.vue?vue&type=style&index=0&id=a634dfb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a634dfb8",
  null
  
)

export default component.exports